import { LoggedInUser } from "../types/types";

const SETTINGS_TABS_PERM_MAPPER = [
    {
        permissionTabName: "Templates",
        permission: "TEMPLATES"
    }
]

export const permCheck = (user: LoggedInUser | undefined, permissionToCheck: string, contextId: string) => {
    if (!user) return false;
    if (user.roles.includes("admin")) return true;
    if (!(contextId in user.context_permissions)) return false;
    return user.context_permissions[contextId].includes(permissionToCheck);
}

export const getAccessibleSettingsPages = (user: LoggedInUser, contextId: string) => {
    const availableSettingsPages: string[] = []
    SETTINGS_TABS_PERM_MAPPER.forEach(el => {
        if (permCheck(user, el.permission, contextId)) {
            availableSettingsPages.push(el.permissionTabName)
        }
    })

    return availableSettingsPages;
}

export const isOnlyDemoAccess = (user: LoggedInUser, contextId: string) => {
    if (!user) return false;
    if (user.roles.includes("admin")) return false;
    if (!(contextId in user.context_permissions)) return false;
    const permissionsOnContext = user.context_permissions[contextId];
    return permissionsOnContext.length === 1 && permissionsOnContext.includes("DEMO");
}